module.exports = __webpack_public_path__ + "static/media/unlock.7b3c71cd.svg";